import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import ConditionedComponent from 'components/ConditionedComponent.js';
import React, { Component } from 'react';
import { Badge} from 'reactstrap';
import Dropdown from 'react-dropdown'
import {  Input } from 'reactstrap';

class LinkedMemberModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nameValue: '',
        }
    }

    onInputType(value) {
        this.setState({nameValue: value});
    }

    setGuildName() {
        this.props.ethereum.guilds.setGuildName(this.props.member.guildId, this.state.nameValue);
        this.props.hide();
    }

    render() {
        if (this.props.member === undefined) {
            console.log('returning nothing');
            return (
                <div></div>
            );
        }
        let userName = this.props.member ? this.props.member.userName : '';
        let guildName = this.props.member ? this.props.member.guildName : undefined;
        return (
            <Modal dialogClassName="preset-modal" show={this.props.member !== undefined} onHide={this.props.hide}>
              <Modal.Header closeButton>
                <Modal.Title>{userName}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ConditionedComponent condition={guildName===''}>
                  Name the guild between you and {userName}
                <Input
                  value={this.state.nameValue}
                  onChange={(event) => this.onInputType(event.target.value)}
                  placeholder="Type name for guild"
                  className="tag-input"/>
                </ConditionedComponent>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => this.setGuildName()}>
                  Ok
                </Button>
                <Button variant="primary" onClick={this.props.hide}>
                  Cancel 
                </Button>
                </Modal.Footer>
                </Modal>
        );
   }
}

export default LinkedMemberModal;
